import APIClient from '@/shared/http/clients/api'

const resourceName = 'QMATemplateAssinatura'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon
const GetQMATemplateListaAssinatura = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetQMATemplateListaAssinatura/${id}`, data, config)
const GetItensAssinatura = (id, fluxo, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetItensAssinatura/${id}/${fluxo}`, data, config)
const GetStatusTipoAssinatura = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetStatusTipoAssinatura`, data, config)
const PostNovoItemAssinatura = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/PostNovoItemAssinatura`, data, config)
const PostEdicaoItemAssinatura = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/PostEdicaoItemAssinatura`, data, config)
const PostExclusaoItemAssinatura = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/PostExclusaoItemAssinatura`, data, config)

const GetItensAssinaturaCadastroBasico = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetItensAssinaturaCadastroBasico?limit=${limit}&index=${index}`, data, config)
// 2026-05-28: inativa UMA juncao de assinatura (acao "Remover deste template" no modal V3 de trava de exclusao)
const InativarJuncaoAssinatura = (juncaoId, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/InativarJuncaoAssinatura/${juncaoId}`, {}, config)

const qmaTemplateSignature = {
  GetQMATemplateListaAssinatura,
  GetItensAssinatura,
  GetStatusTipoAssinatura,
  PostNovoItemAssinatura,
  PostExclusaoItemAssinatura,
  PostEdicaoItemAssinatura,
  GetItensAssinaturaCadastroBasico,
  InativarJuncaoAssinatura
}

export default qmaTemplateSignature



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/qmaTemplateSignature.js